import { render, staticRenderFns } from "./CreateVault.vue?vue&type=template&id=ca6904d8&scoped=true&"
import script from "./CreateVault.vue?vue&type=script&lang=js&"
export * from "./CreateVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6904d8",
  null
  
)

export default component.exports